import React from "react";
import Form from 'react-bootstrap/Form';

const CustomInputs = ({ id, label, type, value, onChange,onBlur, placeholder, message=[], message2=[], 
    className="", disabled=null, autoComplete="off"}) => {
  return (
    <Form.Group>
        {label? <Form.Label>{label}</Form.Label>:label}
        {message[id] !== undefined ? (
            <Form.Text className={message[id].type}>
                {message[id].text}
            </Form.Text>
        ):null}
        <Form.Control
          id={id}
          name={id}
          type={type}
          value={value}
          autoComplete={autoComplete}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          className={className}
          disabled={disabled}
        />
        {message2[id] !== undefined ? (
            <Form.Text className={message2[id].type}>
                {message2[id].text}
            </Form.Text>
        ):null}
    </Form.Group>
  );
};

export default CustomInputs;
